import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import Select, { SingleValue } from "react-select";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { useEffect, useState } from "react";
import { _get, _post } from "../../Utils/Helper";
import { DatePicker } from "antd";
import dayjs from 'dayjs'
import CommonSelect, { Option } from "../../../core/common/commonSelect";
const Calendar = () => {
  interface CalendarEvent {
    id?: number;
    title: string;
    start: string | Date; // Adjust based on how FullCalendar handles start date
    end?: string | Date; // Optional end date
    className?: string;
    status: string;
  }
  const _CalendarEvent = {
    id: 0,
    title: "",
    start: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    end: "",
    className: "bg-default",
    status: "Active",
  }
  // const [calenderevent, setcalenderevent] = useState<CalendarEvent | null>(null);

  const [startDate, setDate] = useState(new Date());
  const [showCategory, setshowCategory] = useState(false);
  const [showmodel, setshowmodel] = useState(false);
  const [showEvents, setshowEvents] = useState(false);
  const [show, setshow] = useState(false);
  const [iseditdelete, setiseditdelete] = useState(false);
  const [addneweventobj, setaddneweventobj] = useState<CalendarEvent>(_CalendarEvent);
  const [isnewevent, setisnewevent] = useState(false);
  const [event_title, setevent_title] = useState("");
  const [category_color, setcategory_color] = useState("primary");
  const [calenderevent, setcalenderevent] = useState<CalendarEvent>(_CalendarEvent); // Updated type
  const [weekendsVisible, setweekendsVisible] = useState(true);
  // const [currentEvents, setscurrentEvents] = useState([]);
  const [currentEvents, setCurrentEvents] = useState<CalendarEvent[]>([]);
  const [form, setForm] = useState({
    category_color: "",
    category_name: ""
  })
  const handleChange = (e: any) => {
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  };
  const [defaultEvents, setDefaultEvents] = useState([])
  const [eventCategories, setEventCategories] = useState([])

  useEffect(() => {
    _get("school-calendar?query_type=select-all&status=Active",
      (resp) => {
        if (resp.data && resp.data.length) {
          setDefaultEvents(resp.data.map((event: any) => ({
            ...event,
            title: event.title,
            start: dayjs(event.start_date, "YYYY-MM-DDTHH:mm:ss.SSS[Z]").format('YYYY-MM-DD'),
            end: dayjs(event.end_date, "YYYY-MM-DDTHH:mm:ss.SSS[Z]").format('YYYY-MM-DD'),
            classNames: event.classNames || 'bg-primary text-white',
          })));
          setshow(false);
        }
      },
      (error) => {
        console.error("Error creating event:", error);
      });
      _get("school-calendar?query_type=Select All Categories&status=Active",
        (resp) => {
          if (resp.data && resp.data.length) {
            setEventCategories(resp.data);
          }
        },
        (error) => {
          console.error("Error creating event:", error);
        });
  }, []);


  useEffect(() => {
    let elements = Array.from(document.getElementsByClassName("react-datepicker-wrapper"));
    elements.map((element) => element.classList.add("width-100"));
  }, []);

  const addEvent = () => {
    setshowEvents(true);
  };

  const categoryHandler = () => {
    setshowCategory(true);
  };

  const handleDateChange = (newValue: any) => {
    // Ensure the newValue is a valid Day.js date object before formatting
    const formattedStartDate =
      newValue?.start && dayjs(newValue?.start).isValid()
        ? dayjs(newValue.start).format('YYYY-MM-DD HH:mm:ss')
        : "";

    setaddneweventobj((prevForm: any) => ({
      ...prevForm,
      start: formattedStartDate,
      end: newValue?.end ? dayjs(newValue.end).format('YYYY-MM-DD HH:mm:ss') : "",
    }));
  };

  const handleClose = () => {
    setisnewevent(false);
    setiseditdelete(false);
    setshow(false);
    setshowCategory(false);
    setshowEvents(false);
    setshowmodel(false);
  };

  const handleEventClick = (clickInfo: any) => {
    setiseditdelete(false);
    setevent_title(clickInfo.event.title);
    setcalenderevent({
      title: clickInfo.event.title,
      start: clickInfo.event.start,
      end: clickInfo.event.end,
      className: clickInfo.event.classNames.join(' '),
      status: clickInfo.event.extendedProps.status,
    });
  };

  const handleDateSelect = (selectInfo: any) => {
    console.error("selectInfo ========>", selectInfo);

    setisnewevent(true);
    setaddneweventobj(selectInfo);
  };

  const onupdateModalClose = () => {
    setiseditdelete(false);
    setevent_title("");
  };

  const handleColorChange = (selectInfo: SingleValue<Option>) => {
    setForm((p) => ({ ...p, 
      category_name:selectInfo?.label ? selectInfo?.label : "",
      category_color: selectInfo?.value ? selectInfo?.value : "" }))
    setcategory_color(selectInfo?.value ? selectInfo?.value : "")
  }

  const handleClick = () => {
    setshow(true);
  };

  const routes = all_routes;
  const colorOptions = [
    { value: "primary", label: "Blue" },
    { value: "success", label: "Green" },
    { value: "danger", label: "Red" },
    { value: "info", label: "Skye Blue" },
    { value: "warning", label: "Yellow" },
    { value: "inverse", label: "White" },
    { value: "purple", label: "Purple" },
  ];

  const defaultValue = colorOptions[0];

  const handleCreateEvent = () => {
    const newEvent = {
      title: event_title,
      start_date: dayjs(addneweventobj.start).format('YYYY-MM-DD HH:mm:ss'),
      end_date: dayjs(addneweventobj.end).format('YYYY-MM-DD HH:mm:ss'),
      color: category_color,
      status: 'Active',
      query_type: 'CREATE',
    };

    _post("school-calendar",
      newEvent,
      (data) => {
        setCurrentEvents((prevEvents) => [...prevEvents, data]);
        setshow(false);
      },
      (error) => {
        console.error("Error creating event:", error);
      });
  };

  const handleUpdateEvent = () => {
    const updatedEvent = {
      ...calenderevent,
      start_date: calenderevent.start,
      end_date: calenderevent.end,
      title: event_title,
      color: category_color,
      status: 'Active',
      query_type: 'UPDATE',
    };

    _post(`school-calendar?query_type=update&id=${calenderevent.id}`,
      updatedEvent,
      (data) => {
        setCurrentEvents((prevEvents) =>
          prevEvents.map((event) =>
            event.id === data.id ? data : event
          )
        );
        setshow(false);
      },
      (error) => {
        console.error("Error updating event:", error);
      });
  };

  const handleDeleteEvent = () => {
    _get(`school-calendar?query_type=select&id=${calenderevent.id}`,
      () => {
        setCurrentEvents((prevEvents) =>
          prevEvents.filter((event) => event.id !== calenderevent.id)
        );
        setshow(false);
      },
      (error) => {
        console.error("Error deleting event:", error);
      });
  };

  const handleCreateCategory = (e: any) => {
    e.preventDefault();
    const newCategory = {
      title: form.category_name,
      category_color: category_color,
      status: 'Active',
      query_type: 'Create Category',
    };

    _post("school-calendar",
      newCategory,
      (data) => {
        setCurrentEvents((prevEvents) => [...prevEvents, data]);
        setshow(false);
      },
      (error) => {
        console.error("Error creating event:", error);
      });
  };
  
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Calendar</h3>
              {/* <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Application</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Calendar
                  </li>
                </ol>
              </nav> */}
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="mb-2">
                <Link to="#" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#add_event">
                  Create Event
                </Link>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          <div className="row">
            <div className="col-lg-3 col-md-4">
              <h4 className="card-title">Drag &amp; Drop Event</h4>
              {defaultEvents.length ? defaultEvents.map((event: any, index: number) => <div id="calendar-events" className="mb-3">
                <div className="calendar-events" data-class="bg-info">
                  <i className="fas fa-circle text-info" /> {event.title}
                </div>
              </div>) : null}
              <div className="checkbox mb-3">
                <input id="drop-remove" className="me-1" type="checkbox" />
                <label htmlFor="drop-remove">Remove after drop</label>
              </div>
              <Link
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#add_new_event"
                className="btn mb-3 btn-primary btn-block w-100"
              >
                <i className="fas fa-plus" /> Add Category
              </Link>
            </div>
            <div className="col-lg-9 col-md-8">
              <div className="card bg-white">
                <div className="card-body">
                  <FullCalendar
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    headerToolbar={{
                      left: "prev,next today",
                      center: "title",
                      right: "dayGridMonth,timeGridWeek,timeGridDay",
                    }}
                    initialView="dayGridMonth"
                    editable={true}
                    selectable={true}
                    selectMirror={true}
                    dayMaxEvents={true}
                    weekends={weekendsVisible}
                    initialEvents={defaultEvents}
                    select={handleDateSelect}
                    eventClick={handleEventClick}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Add Event Modal */}
      <div className="modal fade" id="add_event">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Event:</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                isnewevent ? handleCreateEvent() : handleUpdateEvent();
              }}
            >
              <div className="modal-body pb-0">
                <div className="mb-3">
                  <label className="form-label">
                    Event Name <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={event_title}
                    onChange={(e) => setevent_title(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <div className="cal-icon">
                    <label>Event Category</label>
                    <CommonSelect
                      className={`form-white`}
                      defaultValue={{
                        label: form.category_name,
                        value: form.category_color,
                      }}
                      options={eventCategories.map((x:any, idx:number)=>({label:x.category_name, value:x.category_color}))}
                      handleChange={handleColorChange}
                      placeholder="Pick Color"
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Event Date <span className="text-danger">*</span>
                  </label>
                  <div className="cal-icon">
                    {/* <input
                      className="form-control"
                      type="date"
                      onChange={(event) => addneweventobj((p)=>({...p, start:event.value }))}
                      value={addneweventobj?.start || ""}
                    /> */}

                    <DatePicker
                      className="form-control datetimepicker"
                      format="YYYY-MM-DD"
                      onChange={handleDateChange}
                      // value={form.date_of_birth}
                      value={
                        addneweventobj.start
                          ? dayjs(addneweventobj.start, 'YYYY-MM-DD HH:mm:ss')
                          : null
                      }
                      name={"start"}
                      placeholder="Select Date"
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </Link>
                <button type="submit" className="btn btn-primary">
                  {isnewevent ? "Add Event" : "Update Event"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Add Event Modal */}
      <div className="modal fade" id="add_event">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Event</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form >
              <div className="modal-body pb-0">
                <div className="mb-3">
                  <label className="form-label">
                    Event Name <span className="text-danger">*</span>
                  </label>
                  <input className="form-control" type="text" />
                </div>
                <div className="mb-3">
                  <div className="cal-icon">
                    <label>Event Category</label>
                    <CommonSelect
                      className={`form-white`}
                      defaultValue={{
                        label: form.category_name,
                        value: form.category_color,
                      }}
                      options={eventCategories.map((x:any, idx:number)=>({label:x.category_name, value:x.category_color}))}
                      handleChange={handleColorChange}
                      placeholder="Pick Color"
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Event Date <span className="text-danger">*</span>
                  </label>
                  <div className="cal-icon">
                    <input className="form-control " type="date" />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <Link to="#" className="btn btn-light me-2" data-bs-dismiss="modal">
                  Cancel
                </Link>
                <button type="submit" className="btn btn-primary">
                  Add Event
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* /Add Event Modal */}
      {/* Add Event Modal */}
      <div className="modal custom-modal fade none-border" id="my_event">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Event</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-hidden="true"
              ></button>
            </div>
            <div className="modal-body" />
            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className="btn btn-success save-event submit-btn"
              >
                Create event
              </button>
              <button
                type="button"
                className="btn btn-danger delete-event submit-btn"
                data-dismiss="modal"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Event Modal */}
      {/* Add Category Modal */}
      <div className="modal fade" id="add_new_event">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Category</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="mb-3">
                  <label className="form-label">Category Name</label>
                  <input
                    className="form-control form-white"
                    placeholder="Enter name"
                    type="text"
                    value={form.category_name}
                    onChange={handleChange}
                    name="category_name"
                  />
                </div>
                <div className="mb-3">
                  <label className={`form-label `}>Choose Category Color <span style={{ borderRadius: '50px' }} className={`bg-${category_color || 'primary'} text-white`}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></label>
                  <CommonSelect
                    className={`form-white`}
                    defaultValue={defaultValue}
                    options={colorOptions}
                    handleChange={handleColorChange}

                    placeholder="Pick Color"

                  />

                </div>
              </div>
              <div className="modal-footer">
                <Link to="#" className="btn btn-light me-2" data-bs-dismiss="modal">
                  Cancel
                </Link>
                <button

                  onClick={handleCreateCategory}
                  type="submit" className="btn btn-primary">
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Calendar;
